/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import csvjson from 'csvjson'
import { Link } from '@ta-interaktiv/contentbricks'
import { GlobalColors } from 'components/taCSScolors'
import { PLZ_Table } from 'components/PLZ_Table'
import { NameComparission } from 'components/NameComparission'
import { ImageSwitch } from 'components/ImageSwitch'
import { MetaInfos } from 'components/MetaInfos'
import { WasDieDatenZeigen } from 'components/WasDieDatenZeigen'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { GenderChart } from 'components/GenderChart'
import { Top10 } from 'components/Top10'

import { LocalesProvider } from 'components/_locales/localeContext'

const __locales: localesInterface = require('../_locales/locales.yml')

// TODO Set the correct article ID here
const ARTICLE_ID = '327240021311'
const curveKeys = [
  [__locales.gender.male, 'var(--petrol-main)'],
  [__locales.gender.female, 'var(--red-main)'],
  [__locales.gender.both, 'var(--brand-blue-4)']
]
export function AppComponent() {
  const [draw_data, setDrawData] = useState<drawDataElement[] | undefined>()
  const [dataForComp, setDatAForComp] = useState<
    | [populationdataElementRaw[], womenMenDataElement[], womenMenDataElement[]]
    | undefined
  >()
  const [top10Data, setTop10Data] = useState<
    womenMenDataElement[][] | undefined
  >()
  const [newborn, setNewborn] = useState<womenMenDataElement[][] | undefined>()

  useEffect(() => {
    let urls = [
      '_data/chart_data.csv',
      '_data/population.csv',
      '_data/womens.csv',
      '_data/mens.csv',
      '_data/swiss_names.csv',
      '_data/swiss_names_2019.csv'
    ]

    Promise.all(urls.map(url => fetch(url)))
      .then(resp => Promise.all(resp.map(r => r.text())))
      .then(result => {
        let data = csvjson.toObject(result[0], {}).map(a => {
          return a
        })
        setDrawData(data)

        /**
         *
         * Name Comparisson
         *
         *
         */
        let pop = csvjson.toObject(result[1], {})
        let women = csvjson.toObject(result[2], {})
        let men = csvjson.toObject(result[3], {})
        setDatAForComp([pop, men, women])
        /**
         *
         * Ranking
         *
         *
         */ type swissNameObject = {
          name: string
          count: string
          gender: 'm' | 'f'
        }
        let swissNames = csvjson.toObject(result[4], {})
        let swissMen = swissNames
          .filter((f: swissNameObject) => f.gender === 'm')
          .sort((a: swissNameObject, b: swissNameObject) => +b.count - +a.count)
          .map((m: swissNameObject, i: number) => {
            return [m.name, +m.count, i + 1]
          })
        let swissWomen = swissNames
          .filter((f: swissNameObject) => f.gender === 'f')
          .sort((a: swissNameObject, b: swissNameObject) => +b.count - +a.count)
          .map((m: swissNameObject, i: number) => {
            return [m.name, +m.count, i + 1]
          })
        setTop10Data([swissMen, swissWomen])
        /**
         *
         * Newborn
         *
         *
         */
        let swissNames2019 = csvjson.toObject(result[5], {})
        let swissBoys = swissNames2019
          .filter((f: swissNameObject) => f.gender === 'm')
          .sort((a: swissNameObject, b: swissNameObject) => +b.count - +a.count)
          .map((m: swissNameObject, i: number) => {
            return [m.name, +m.count, i + 1]
          })
        let swissGirls = swissNames2019
          .filter((f: swissNameObject) => f.gender === 'f')
          .sort((a: swissNameObject, b: swissNameObject) => +b.count - +a.count)
          .map((m: swissNameObject, i: number) => {
            return [m.name, +m.count, i + 1]
          })
        setNewborn([swissBoys, swissGirls])
      })
  }, [])
  return (
    <LocalesProvider value={__locales}>
      <div className='index'>
        <GlobalColors />
        <Masthead articleId={ARTICLE_ID} inverted />
        <ThemeSwitch />
        <header className='ui vertical segment'>
          <div className='ui container'>
            <div className='ui header'>
              <h1>{__locales.main.title}</h1>
              <h2>{__locales.main.lead}</h2>
            </div>
          </div>
        </header>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <MetaInfos
              authors={__locales.main.authors}
              updated={__locales.main.updated}
            />
            <div className='ta text'>
              <p>
                Mia und Noah waren 2020 in der Schweiz die beliebtesten Vornamen
                für Neugeborene. Noah überholte Liam und verwies diesen auf
                Platz zwei. Mia führte schon{' '}
                <Link allowWordWrap href='871258413235'>
                  2019 die weibliche Vornamen-Hitparade
                </Link>{' '}
                an. Emma war wie im Vorjahr erneut der zweitbeliebteste
                Mädchenname.
              </p>
              <p>
                Noah war bereits 2010, 2011 sowie von 2013 bis 2017 am
                beliebtesten gewesen. 507 Knaben bekamen den Namen letztes Jahr.
                Der Bubenname Liam wurde 372 Mal vergeben, knapp gefolgt von
                Matteo mit 359.
              </p>
              <p>
                Auch Mia war wie Noah schon mehrmals auf Platz eins, nämlich
                2013, 2015, 2016 und 2019. Seit dem letzten Jahr gibt es nun 461
                Mädchen mehr mit diesem Namen. Den zweitbeliebtesten Namen Emma
                haben neu 407 Mädchen bekommen, 350 Babys wurden Mila genannt,
                was Platz drei bedeutet.
              </p>
            </div>
          </div>
        </div>
        {newborn && (
          <Top10 data={newborn} locales={__locales.ranking_newborn} />
        )}

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <p>
              Die meistgewählten Vornamen 2020 unterscheiden sich nach
              Sprachregion. In der Deutschschweiz stehen Noah und Mia an erster
              Stelle, während in der französischsprachigen Schweiz Gabriel und
              Emma das Rennen machen. In der italienischsprachigen Schweiz
              stehen Leonardo und Sofia zuoberst auf dem Treppchen. Auch
              zwischen den Kantonen gibt es unterschiedliche Vorlieben, wie
              unsere Karten zeigen.
            </p>
            <ImageSwitch
              images={[
                require('images/vornamen_2020_men.png'),
                require('images/vornamen_2020_women.png')
              ]}
              labels={[
                [
                  'Gabriel im Wallis, Mauro in Glarus',
                  'Die beliebtesten Knabennamen in den Kantonen'
                ],
                [
                  'Emma in Genf, Gianna in Appenzell',
                  'Die beliebtesten Mädchennamen in den Kantonen'
                ]
              ]}
            />
          </div>
        </div>

        <div className='ui vertical  segment'>
          <div className='ui text container'>
            <div className='ta text'>
              In der Schweiz lässt sich die BFS-Vornamenstatistik auch in
              relativen Zahlen pro Jahrgang abfragen. So sind aussagekräftige
              Vergleiche verschiedener Vornamen punkto Beliebtheit über die
              Jahre möglich.
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          {dataForComp && <NameComparission data={dataForComp} />}
        </div>
        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <WasDieDatenZeigen data={__locales.expressiveness} />
            <div className='ta text'>
              <p>
                Auch wenn sich der Name Daniel im Abschwung befindet, ist er
                immer noch jener männliche Vorname, der in der Gesamtbevölkerung
                am häufigsten vorkommt. Mehr als 62'000 Daniels gibt es in der
                Schweiz. Dahinter kommen die knapp 57'000 Peters und 52’000
                Thomas’.
              </p>
              <p>
                Bei den Frauen ist Maria immer noch der häufigste Vorname in der
                Schweiz. Knapp 80’000 Frauen und Mädchen heissen so. Dahinter
                folgen Anna und Sandra.
              </p>
            </div>
          </div>
        </div>
        {top10Data && (
          <Top10 data={top10Data} locales={__locales.ranking_all} />
        )}

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              Nachdem es von 1980 bis in die 1990er-Jahre einen klaren Trend zur
              Individualisierung der Vornamen gab, wählen die Schweizer Eltern
              seit Ende der 1990er-Jahre wieder vermehrt ähnliche Vornamen aus.
            </div>
          </div>
        </div>
        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {draw_data && (
              <GenderChart
                title={__locales.charts[3].title}
                sub={__locales.charts[3].sub}
                curves={[
                  draw_data.map(m => [+m.year, +m.count_M]),
                  draw_data.map(m => [+m.year, +m.count_W]),
                  draw_data.map(m => [+m.year, +m.count_B])
                ]}
                keys={curveKeys}
                axisLabels={__locales.charts[3].axis}
                yDomain={[0, 2000]}
                yTickStep={500}
              />
            )}
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              Mit Mia und Noah wurden im Jahr 2020 erneut zwei kurze Namen am
              häufigsten vergeben. Die mittlere Vornamenslänge der im Jahr 2019
              Geborenen liegt bei knapp 5,8 Zeichen. Ältere Personen haben
              tendenziell längere Vornamen.
            </div>
          </div>
        </div>
        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {draw_data && (
              <GenderChart
                title={__locales.charts[1].title}
                sub={__locales.charts[1].sub}
                curves={[
                  draw_data.map(m => [+m.year, +m.aveLength_M]),
                  draw_data.map(m => [+m.year, +m.aveLength_W]),
                  draw_data.map(m => [+m.year, +m.aveLength_B])
                ]}
                keys={curveKeys}
                axisLabels={__locales.charts[1].axis}
                yDomain={[5, 7]}
                yTickStep={0.5}
              />
            )}
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              Suchen Sie zum Schluss noch die häufigsten Vornamen in Ihrem
              PLZ-Gebiet. Vornamen, die gesamthaft weniger als fünfmal
              vorkommen, werden aus Datenschutzgründen nicht angezeigt.
            </div>
          </div>
        </div>

        <div className='ui vertical segment'>
          <PLZ_Table />
        </div>

        <Footer
          questions={[
            'Wie unterhaltsam war der Beitrag?',
            'Wie gefällt Ihnen die Gestaltung?',
            'Wie gut funktionierte die technische Umsetzung?'
          ]}
          articleId={ARTICLE_ID}
          hidePortfolioTeaser
          credits={__locales.credits}
          inverted
        />
      </div>
    </LocalesProvider>
  )
}
{
  /* <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {draw_data && (
              <GenderChart
                title={__locales.charts[0].title}
                sub={__locales.charts[0].sub}
                curves={[
                  draw_data.map(m => [+m.year, +m.personsPerName_M]),
                  draw_data.map(m => [+m.year, +m.personsPerName_W]),
                  draw_data.map(m => [+m.year, +m.personsPerName_B])
                ]}
                keys={curveKeys}
                axisLabels={__locales.charts[0].axis}
                yDomain={[0, 80]}
                yTickStep={20}
              />
            )}
          </div>
        </div> */
}
